import { Link } from "react-router-dom";

export const LOGIN_LEGAL_AGREE_PROMPT = {
  title: "服务协议确认",
  uncheckedTip: "请先阅读并同意用户协议和隐私政策",
  children: (
    <span>
      我已阅读并同意
      <Link
        className="legal-agree-prompt-link"
        to="/legal/user-agreement"
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        《用户协议》
      </Link>
      与
      <Link
        className="legal-agree-prompt-link"
        to="/legal/privacy"
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        《隐私政策》
      </Link>
    </span>
  ),
};

export const CREATOR_LEGAL_AGREE_PROMPT = {
  title: "入驻规则确认",
  uncheckedTip: "请先阅读并同意大V入驻规则",
  children: (
    <span>
      我已阅读并同意
      <Link
        className="legal-agree-prompt-link"
        to="/legal/creator"
        target="_blank"
        rel="noreferrer"
        onClick={(e) => e.stopPropagation()}
      >
        《大V入驻规则》
      </Link>
    </span>
  ),
};
